import MixPanelConstant from './MixPanelConstant';
import {
    MATERIALS_IN_EXTERNAL_WALL_FILTER,
    MATERIALS_IN_ROOF_FILTER,
    RAPID_PROPERTY_TYPE_V2_TENURE
} from '../Localization';
import { isNZ } from '../../constants/crux';
import COUNTRY from '../../constants/countries';

const evaluateDefaultProperties = (statusType, filters) => {
    const country = isNZ ? COUNTRY.NZ : COUNTRY.AU;

    MixPanelConstant.DEFAULT_PROPERTIES[statusType].forEach((property) => {
        if (!filters[property.name]) {
            if (property.country && property.country.length > 0) {
                if (country === property.country) {
                    filters[property.name] = property.defaultValue;
                }
            } else {
                filters[property.name] = property.defaultValue;
            }
        }
    });
};

const constructTenureData = (filters, eventProps) => {
    if (filters?.tenureData) {
        const house = {
            value: filters?.tenureData?.holdPeriodHouse,
            label: 'holdPeriodHouse',
        };
        const values = {
            house,
            'residential': house,
            'unit': {
                value: filters?.tenureData.holdPeriodUnit,
                label: 'holdPeriodUnit',
            },
        };
        let types = filters?.type.split(',');
        types = !types.length || filters?.type.toLowerCase() === 'all'
            ? RAPID_PROPERTY_TYPE_V2_TENURE.map((type) => type.value)
            : types;

        types.forEach((type) => {
            const { label, value } = values[type.toLowerCase()];
            const formatter = MixPanelConstant.PROPERTIES[label];
            if (value?.min && value?.max) {
                formatter.construct(
                    formatter.label,
                    value,
                    eventProps,
                );
            }
        });

    }
};

const constructMixpanelProperties = (statusType, activeView, filters) => {
    const eventProps = [
        { label: 'Page', value: 'Search' },
        { label: 'Search Tab', value: MixPanelConstant.TABS_ATTR[statusType] },
        { label: 'Result View', value: activeView },
    ];
    evaluateDefaultProperties(statusType, filters);
    Object.keys(filters).forEach((key) => {
        const filterValue = filters[key];
        const fieldObject = MixPanelConstant.PROPERTIES[key];
        if (fieldObject) {
            const eventPropsLabel = MixPanelConstant.PROPERTIES[key].label;
            MixPanelConstant.PROPERTIES[key].construct(eventPropsLabel, filterValue, eventProps);
        }
    });

    //This loop is for the default false values in the MixPanel event for boolean values
    [
        'canalFrontage', 'coastFrontage', 'golfFrontage', 'highExposure',
        'lakeFrontage', 'riverFrontage', 'scenicView', 'waterFrontage',
        'accessAvailable24Hrs', 'accessSecurityInstalled', 'closeToPublicTransport', 'liftInstalled',
        'onMainRoad', 'sewage', 'townSewerageAvailable', 'townWaterAvailable',
        'water', 'allWeatherAccessToLand', 'allWeatherRoadsToFarm', 'permanentWater',
        'sealedRoadsToProperty', 'airConditioned', 'builtInWardrobes', 'ductedHeating',
        'ductedVacuum', 'fireplace', 'openPlan', 'polishedFloors', 'renovated',
        'heritageOtherClassification', 'freeStandingBuilding', 'boatRampMooringSpace',
        'fenced', 'grannyFlatSelfContained', MATERIALS_IN_EXTERNAL_WALL_FILTER,
        MATERIALS_IN_ROOF_FILTER, 'swimmingPool', 'treesOnLand', 'rentalOccupancy',
    ].forEach((key) => {
        if (!filters[key]) {
            const eventPropsLabel = MixPanelConstant.PROPERTIES[key].label;
            MixPanelConstant.PROPERTIES[key].construct(eventPropsLabel, false, eventProps);
        }
    });

    constructTenureData(filters, eventProps);

    return eventProps;
};

export default {
    constructMixpanelProperties,
};
